import { TFunction } from 'i18next';
import { SuggestedFaqStatus } from '@/models/suggestedFaq.model';
import { TSelectOptions } from '@/ui';

export const getSuggestedFaqStatusOptions = (t: TFunction): TSelectOptions<SuggestedFaqStatus> =>
  Object.values(SuggestedFaqStatus).map((status) => ({
    label: t(`status_${status}`),
    value: status,
  }));
